<ng-container *ngIf="propertyDetailsPage">
  <div class="fancy-hero-one coutom_header">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 m-auto hdr_with_btn">
          <a class="back_wrap" routerLink="/user-property-list"><img src="assets/images/assets/back.png" alt="Back" title="Back" /></a>
          <h3 class="font-rubik">{{name}} ({{mobile_no}})</h3> 
          <a class="logout_wrap" (click)="logout()"><img  src="assets/images/assets/logout.png" alt="Logout" title="Logout" /></a>
          <button class="hdr_btn theme-btn-six" [routerLink]="['/register-property']">Add New Asset</button>
        </div>
      </div>
    </div>
  </div>

  <div class="coutom_two">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 m-auto hdr_with_btn">
          <!-- <div class="page-title">Contact us</div> -->
          <h2 class="font-rubik">Asset Detail</h2> 
        </div>
      </div>
    </div>
  </div>
    
    <div class="hero-banner-one contact-us-light">
      <div class="hero-upper-container">
        <div *ngIf="redirection_payment == 'FAILED'" class="mb-25" style="color: red;"> 
          Your payment transaction has failed. Please try again.
      </div>
        <div class="container">
          <div class="details_wrap">
            <ul>
              <li><label>Asset ID : </label>{{property_detail?.property_uid}}</li>
              <li><label>Name of Household : </label>{{property_detail?.consumer?.name}}</li>
              <li><label>Address : </label>{{property_detail?.consumer?.address}}</li>
            </ul>
            <ul>
              <li><label>Asset Type : </label> {{property_detail?.property_type?.type_name}}</li>
              <li><label>ULB : </label> {{property_detail?.ulb?.name}}</li>
              <li><label>Zone : </label> {{property_detail?.region?.parents?.region_name}}</li>
              <li><label>Ward : </label> {{property_detail?.region?.region_name}}</li>
            </ul>
          </div>
    
          <div class="table_wrap">
              <table class="table table_design mt-100">
                <thead>
                  <tr>
                    <th scope="col">Service Identifier</th>
                    <th scope="col">Service Type</th>
                    <th scope="col">Area</th>
                    <th scope="col">Current Bill Amount</th>
                    <th scope="col">Arrear</th>
                    <th scope="col">Total Due</th>
                    <th scope="col">Select</th>
                    <!-- <th *ngIf="property_detail.services.length > 1" scope="col"><input style="margin-right: 10px;" type="checkbox" [(ngModel)]="selectAll"
                        (ngModelChange)="onSelectAllChange()">Select All</th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of property_detail.services; index as i">
                    <td scope="row">
                      <span *ngIf="property_detail.is_approved == false">Pending Approval</span>
                      <span *ngIf="property_detail.is_approved == true">{{ data?.service_identifier}}</span>
                    </td>
                    <td scope="row">{{ data?.service_type?.name }}</td>
                    <td scope="row">{{ data?.area }}</td>
                    <td scope="row"><span *ngIf="data?.amount >= 0">{{ data?.amount | currency:'INR' }}</span></td>
                    <td scope="row"><span *ngIf="data?.amount >= 0">{{ data?.last_due | currency:'INR' }}</span></td>
                    <td scope="row"><span *ngIf="data?.amount >= 0">{{ data?.payable_total_amount | currency:'INR' }}</span></td>
                    <td  scope="row">
                      <!-- <input style="margin-left: 10px;" type="checkbox" [(ngModel)]="data.ischecked" (change)="checkBoxChange($event, i)"> -->
                      <input type="radio" name="selectedItem" [value]="i" [(ngModel)]="selectedRowIndex"
                      (change)="amount = data?.payable_total_amount">
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="form-style-light input_pay" *ngIf="property_detail?.services && property_detail?.services.length">
              <div class="pay_details" >
                <ul>
                  <li><label>Service Identifier : </label> {{property_detail?.services[selectedRowIndex].service_identifier}}</li>
                  <li><label>Service Type : </label> {{property_detail?.services[selectedRowIndex].service_type?.name}}</li>
                  <li><label>Area : </label> {{property_detail?.services[selectedRowIndex].area}}</li>
                </ul>
                <ul>
                  <li><label>Current Bill Amount : </label> {{property_detail?.services[selectedRowIndex].amount | currency:'INR' }}</li>
                  <li><label>Arrear : </label> {{property_detail?.services[selectedRowIndex].last_due | currency:'INR' }}</li>
                  <li><label>Total Due : </label> {{property_detail?.services[selectedRowIndex].payable_total_amount | currency:'INR' }}</li>
                </ul>
              </div>

              <a href="javascript:;" style="text-decoration: underline;" (click)="amount = property_detail?.services[selectedRowIndex].payable_total_amount; is_partial_payment = false">Pay Total Due</a>
              <a  href="javascript:;" style="text-decoration: underline; margin-left: 10px;" (click)="amount = property_detail?.services[selectedRowIndex].minimum_payable_amount; is_partial_payment = false">Pay Minimum</a>
              <a  href="javascript:;" style="text-decoration: underline; margin-left: 10px;" (click)="amount = property_detail?.services[selectedRowIndex].minimum_payable_amount; is_partial_payment = true">Enter Other Amount</a>

              <div class="input-group-meta form-group pay_input" style="margin-top: 20px;">
                <label>Amount</label>
                <input type="number" [disabled]="!is_partial_payment" name="amount" #amountInpt="ngModel" [(ngModel)]="amount"
                  [min]="property_detail?.services[selectedRowIndex].minimum_payable_amount"
                  [max]="property_detail?.services[selectedRowIndex].payable_total_amount">
                <h6 style="display: block;" *ngIf="amountInpt.errors && (amountInpt.errors['min'] || amountInpt.errors['max'])">Amount must be
                  between {{property_detail?.services[selectedRowIndex].minimum_payable_amount}} - {{property_detail?.services[selectedRowIndex].payable_total_amount}}</h6>
              </div>

              <button class="theme-btn-one btn-lg mt-20" [ngClass]="{'disabled': (amount == 0 ||  amountInpt.errors)}" (click)="onClickPay()">Pay</button>


            </div>
        </div>
      </div>
    </div>
    </ng-container>